import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { MonacoEditorModule } from 'ngx-monaco-editor';
import { AppComponent } from './app.component';
import { CopyClipboardDirective } from './copy-clipboard.directive';


@NgModule({
  declarations: [
    AppComponent,
    CopyClipboardDirective
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    MonacoEditorModule.forRoot()
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
